import { AppState } from '../types/AppState';
import { Group } from '../types/Group';

/**
 * Gets the group of the currentUser or undefined
 *
 * @param appState
 */
export const getGroupOrUndefined = (appState: AppState): Group | undefined => appState.currentUser.group;
